<template>
  <v-dialog
    width="330"
    v-model="modal">
    <v-btn
      slot="activator"
      light primary
      :loading="fetchingAudio">
      {{ $t('purchase.callplayer.title') }}
    </v-btn>
    <v-card
      v-if="src">
      <v-card-text>
        <template v-if="fetchingAudio">
          <v-progress-linear :indeterminate="true" height="2"></v-progress-linear>
        </template>
        <template v-else>
          <audio
            v-if="src && !error"
            :src="src"
            type="audio/wav"
            autoplay="autoplay"
            controls="controls"
            preload="auto">
          </audio>
          <span v-else>{{ $t('purchase.callplayer.error') }}</span>
        </template>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapActions } from 'vuex'
  import purchase from '@/mixins/purchase'
  export default {
    mixins: [purchase],
    data () {
      return {
        src: null,
        modal: false,
        fetchingAudio: false,
        error: false
      }
    },
    watch: {
      modal () {
        if (this.modal) { this.fetchAudio() }
      }
    },
    methods: {
      ...mapActions({
        _fetchAudio: 'skiliko/call/fetchAudio'
      }),
      fetchAudio () {
        this.fetchingAudio = true
        this._fetchAudio({ id: this.purchase.id })
          .then(audio => {
            this.src = audio.endpoint
            this.fetchingAudio = false
          })
          .catch(_ => {
            this.error = true
            this.fetchingAudio = false
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/purchase/CallPlayer.vue